// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*************** 
GENERAL 
***************/

.svg-wrapper {
  width: 100%;
}

/* .svg-wrapper svg {
  width: 100% !important;
  height: 100% !important;
} */

svg [id^="button-"] {
  cursor: pointer;
}

.color-normal-white {
  color: #fff;
}

.color-danger-red {
  color: var(--os-graphical-device-text-danger);
}

.color-warning-orange {
  color: var(--os-kontram-warning);
}

.color-success-green {
  color: var(--os-kontram-primary);
}

/* 
ALERT STYLING 
*/

/* DEVICE CARD (BOX) */
svg rect.alarm-active {
  stroke: var(--os-graphical-device-alarm-stroke);
  stroke-width: 1px;
}

/* ICON */
svg path.alarm-active {
  fill: var(--os-graphical-device-alarm-fill);
  animation: alarm-animation 5s linear infinite alternate;
}

@keyframes alarm-animation {
  84% {
    fill: var(--os-graphical-device-alarm-fill);
  }

  92% {
    fill: rgba(255, 255, 255, 0);
  }

  100% {
    fill: var(--os-graphical-device-alarm-fill);
  }
}

/*
PENDINGS
TODO: Refactor this to be generic
*/

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  20% {
    transform: rotate(180deg);
  }

  60% {
    transform: rotate(180deg);
  }

  80% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.pending-single {
  transform-origin: center;
  transform-box: fill-box;
  animation: spin 4s linear infinite;
}

@keyframes blinkGreen {
  50% {
    fill: var(--os-graphical-device-fill-dark-green);
  }

  0%,
  35%,
  100% {
    fill: var(--os-graphical-device-fill-neutral);
  }
}

@keyframes blinkOrange {
  50% {
    fill: var(--os-kontram-warning);
  }

  0%,
  35%,
  100% {
    fill: var(--os-graphical-device-fill-neutral);
  }
}

.green-blink {
  animation: blinkGreen 1.5s linear infinite;
}

.orange-blink {
  animation: blinkOrange 1.5s linear infinite;
}

@keyframes blinkText {
  0%,
  30%,
  70%,
  100% {
    fill: white;
  }

  50% {
    fill: var(--os-graphical-device-fill-pale-yellow);
  }
}

.blink-text {
  animation: blinkText 2s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/Dashboard/components/graphicalView/2D/style.css"],"names":[],"mappings":"AAAA;;eAEe;;AAEf;EACE,WAAW;AACb;;AAEA;;;GAGG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;CAEC;;AAED,sBAAsB;AACtB;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,2CAA2C;EAC3C,uDAAuD;AACzD;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA;;;CAGC;;AAED;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;;;IAGE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;;;IAGE,6CAA6C;EAC/C;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;;;;IAIE,WAAW;EACb;;EAEA;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":["/*************** \nGENERAL \n***************/\n\n.svg-wrapper {\n  width: 100%;\n}\n\n/* .svg-wrapper svg {\n  width: 100% !important;\n  height: 100% !important;\n} */\n\nsvg [id^=\"button-\"] {\n  cursor: pointer;\n}\n\n.color-normal-white {\n  color: #fff;\n}\n\n.color-danger-red {\n  color: var(--os-graphical-device-text-danger);\n}\n\n.color-warning-orange {\n  color: var(--os-kontram-warning);\n}\n\n.color-success-green {\n  color: var(--os-kontram-primary);\n}\n\n/* \nALERT STYLING \n*/\n\n/* DEVICE CARD (BOX) */\nsvg rect.alarm-active {\n  stroke: var(--os-graphical-device-alarm-stroke);\n  stroke-width: 1px;\n}\n\n/* ICON */\nsvg path.alarm-active {\n  fill: var(--os-graphical-device-alarm-fill);\n  animation: alarm-animation 5s linear infinite alternate;\n}\n\n@keyframes alarm-animation {\n  84% {\n    fill: var(--os-graphical-device-alarm-fill);\n  }\n\n  92% {\n    fill: rgba(255, 255, 255, 0);\n  }\n\n  100% {\n    fill: var(--os-graphical-device-alarm-fill);\n  }\n}\n\n/*\nPENDINGS\nTODO: Refactor this to be generic\n*/\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  20% {\n    transform: rotate(180deg);\n  }\n\n  60% {\n    transform: rotate(180deg);\n  }\n\n  80% {\n    transform: rotate(360deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.pending-single {\n  transform-origin: center;\n  transform-box: fill-box;\n  animation: spin 4s linear infinite;\n}\n\n@keyframes blinkGreen {\n  50% {\n    fill: var(--os-graphical-device-fill-dark-green);\n  }\n\n  0%,\n  35%,\n  100% {\n    fill: var(--os-graphical-device-fill-neutral);\n  }\n}\n\n@keyframes blinkOrange {\n  50% {\n    fill: var(--os-kontram-warning);\n  }\n\n  0%,\n  35%,\n  100% {\n    fill: var(--os-graphical-device-fill-neutral);\n  }\n}\n\n.green-blink {\n  animation: blinkGreen 1.5s linear infinite;\n}\n\n.orange-blink {\n  animation: blinkOrange 1.5s linear infinite;\n}\n\n@keyframes blinkText {\n  0%,\n  30%,\n  70%,\n  100% {\n    fill: white;\n  }\n\n  50% {\n    fill: var(--os-graphical-device-fill-pale-yellow);\n  }\n}\n\n.blink-text {\n  animation: blinkText 2s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
